import React from 'react';
import PropTypes from 'prop-types';
import { Trans } from 'lingui-react';

import getComplaintText from 'utils/complaint';

import Widget from 'elements/Widget';

import CaseComplaintContainer from './CaseComplaintContainer';
import ServiceRequestComplaintContainer from './ServiceRequestComplaintContainer';

import Title from './Title';
import Content from './Content';
import messages from './messages';

export function ComplaintWidget({
  info,
}) {
  const { title, content } = getComplaintText(info, {
    titleInLink: false,
  });

  return (
    <Widget id="complaints" expandKey="complaints">
      <Widget.Header>
        <Trans id={messages.title} />
      </Widget.Header>
      <Widget.Item>
        <Title>
          {title}
        </Title>
        <Content>
          {content}
        </Content>
      </Widget.Item>
    </Widget>
  );
}


ComplaintWidget.propTypes = {
  info: PropTypes.shape({
    complaint: PropTypes.shape({
      code: PropTypes.string,
      description: PropTypes.string,
    }),
    description: PropTypes.string,
  }).isRequired,
};

const WidgetWithCommonHOCS = ComplaintWidget;

export const CaseComplaintWidget = CaseComplaintContainer(WidgetWithCommonHOCS);
export const ServiceRequestComplaintWidget = ServiceRequestComplaintContainer(WidgetWithCommonHOCS);



// WEBPACK FOOTER //
// ./compositions/ComplaintWidget/index.js